import { render, staticRenderFns } from "./CreateDriverGroup.vue?vue&type=template&id=0916b97a&"
import script from "./CreateDriverGroup.vue?vue&type=script&lang=js&"
export * from "./CreateDriverGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports